import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "../env";
import Navbar from "../../src/components/Navbar";

const UpdateQuizTime = (history) => {
	const [quizTime, setTime] = useState("");
	const [quizId, setId] = useState("");
	const [_id, setiD] = useState("");

	useEffect(() => {
		fetch(BASE_URL + "/quiz", {
			method: "GET",
			headers: { "content-type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				console.log("id", data[0]._id);
				setTime(data[0].quizTime);
				setId(data[0].quizId);
				setiD(data[0]._id);

				console.log(quizId);
			});
	}, []);

	return (
		<div>
			<Navbar />
			<h1 className="text-center my-5">Update Quiz Time And Id</h1>

			<div className="container">
				<table class="table">
					<thead>
						<tr>
							<th scope="col">#</th>
							<th scope="col">Quiz Time</th>
							<th scope="col">Quiz Id</th>
							<th scope="col">Update</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th scope="row">1</th>
							<td>{quizTime}</td>
							<td>{quizId}</td>
							<td>
								<button className="btn btn-warning">
									<Link to={`quizUpdate/${_id}`}>
										Update{" "}
									</Link>{" "}
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default UpdateQuizTime;
